import { Lien, useRoute } from "../lib/router.tsx";
import { SCREENS, accueilRole } from "./config.ts";
import { useApp } from "./state.tsx";

export function FilAriane(): React.ReactElement {
  const { chemin } = useRoute();
  const app = useApp();
  const accueil = accueilRole(app.role);
  const segments = chemin.split("/").filter(Boolean);
  const liens = [{ chemin: accueil, label: "Tableau de bord" }];
  for (let i = 1; i <= segments.length; i++) {
    const route = "/" + segments.slice(0, i).join("/");
    if (route === accueil || route === "/login" || (i === 1 && !SCREENS[route])) continue;
    const segment = segments[i - 1];
    const label = SCREENS[route]?.label ?? (segment === "nouveau" ? "Créer" : segment === "editer" ? "Modifier" : i > 2 ? "Fiche" : segment === "conferenciers" ? "Conférenciers" : segment);
    if (label) liens.push({ chemin: route, label });
  }
  return (
    <nav aria-label="Fil d’Ariane" style={{ marginBottom: 18 }}>
      <ol style={{ listStyle: "none", padding: 0, margin: 0, display: "flex", flexWrap: "wrap", gap: 8, fontSize: 13 }}>
        {liens.map((lien, i) => <li key={lien.chemin}>
          {i > 0 && <span aria-hidden="true" style={{ marginRight: 8 }}>›</span>}
          {i === liens.length - 1 ? <span aria-current="page">{lien.label}</span> : <Lien vers={lien.chemin}>{lien.label}</Lien>}
        </li>)}
      </ol>
    </nav>
  );
}
